import { IonIcon } from "@ionic/react";
import { t } from "i18next";
import { flashOutline } from "ionicons/icons";
import React from "react";

export const OfficialIcon = (props: any) => (
  <IonIcon
    icon={flashOutline}
    title={t("officialChannel") || ""}
    style={{
      color: "var(--ion-color-primary)",
    }}
    className={props.className}
  />
);
